import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // note, the status target is so that we can have an absolute positioning wrapper so they
  // float inside of the input field
  static targets = ["input", "status", "found", "notFound"];
  static values = { checkUrl: String };

  connect() {
    this.debounceTimer = null;
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }

  validateBarcode() {
    const barcode = this.inputTarget.value.trim();

    clearTimeout(this.debounceTimer);
    this.hideStatus();

    if (barcode === "") {
      return;
    }

    // debounce the API call
    this.debounceTimer = setTimeout(() => {
      this.checkBarcode(barcode);
    }, 600);
  }

  checkBarcode(barcode) {
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content");

    fetch(`${this.checkUrlValue}?barcode=${encodeURIComponent(barcode)}&_=${Date.now()}`, {
      headers: {
        "X-CSRF-Token": token,
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.showStatus(data.status, data.customer_name);
      })
      .catch((error) => {
        this.hideStatus();
      });
  }

  showStatus(status, customerName) {
    this.statusTarget.classList.remove("hidden");

    // reset visibility
    this.foundTarget.classList.add("hidden");
    this.notFoundTarget.classList.add("hidden");

    if (status === "found") {
      this.foundTarget.classList.remove("hidden");
      if (customerName) {
        this.foundTarget.textContent = `Found! (${customerName})`;
      } else {
        this.foundTarget.textContent = "Found!";
      }
    } else if (status === "not_found") {
      this.notFoundTarget.classList.remove("hidden");
      this.notFoundTarget.textContent = "Not found";
    }
  }

  hideStatus() {
    this.statusTarget.classList.add("hidden");
    this.foundTarget.classList.add("hidden");
    this.notFoundTarget.classList.add("hidden");
  }
}
